<sl-label size="large" i18n="@@AccountEditorView.Title">Your Profile</sl-label>

<sl-card>
    <form [formGroup]="form" (ngSubmit)="submit()" autocomplete="off">
        <sl-input size="small" formControlName="name" label="Name" i18n-label="@@AccountEditorView.Name"></sl-input>
        <sl-fieldset size="small" class="mt-4" style="display:block" label="Address"
            i18n-label="@@AccountEditorView.Address">
            <sl-fieldrow>
                <sl-input formControlName="street" placeholder="Street and housenumber"
                    i18n-placeholder="@@AccountEditorView.StreetPlaceholder" width="3/4"></sl-input>
                <sl-input formControlName="apartment" placeholder="floor/apt."
                    i18n-placeholder="@@AccountEditorView.FloorPlaceholder" width="1/4"></sl-input>
            </sl-fieldrow>
            <sl-fieldrow>
                <sl-input formControlName="postalCode" placeholder="Zip"
                    i18n-placeholder="@@AccountEditorView.ZipPlaceholder" width="1/4"></sl-input>
                <sl-input formControlName="city" placeholder="City"
                    i18n-placeholder="@@AccountEditorView.CityPlaceholder" width="1/2"></sl-input>
                <sl-select width="1/4" formControlName="countryCode" width="1/4">
                    <sl-menu-item value="FO" i18n>Faroe Islands</sl-menu-item>
                    <sl-menu-item value="DK" i18n>Denmark</sl-menu-item>
                    <sl-menu-item value="NO" i18n>Norway</sl-menu-item>
                </sl-select>
            </sl-fieldrow>
            <span *ngIf="form.get('street')?.errors || form.get('postalCode')?.errors || form.get('city')?.errors || form.get('countryCode')?.errors" slot="error-text" 
                i18n="@@AccountEditorView.ValidAddress">Must have address specified.</span>
        </sl-fieldset>
        <div class="grid grid-cols-2 gap-4">
            <sl-input size="small" class="mt-4" formControlName="phone" label="Phone"
                i18n-label="@@AccountEditorView.Phone" type="phone">
                <span *ngIf="form.get('phone')?.errors" slot="error-text" 
                i18n="@@AccountEditorView.ValidPhone">Must be a valid number incl. country code</span>
            </sl-input>
        </div>
        <div class="text-right">
            <sl-button size="small" class="mt-4" type="primary" (click)="submit()"
                [disabled]="!form.valid || form.pristine" i18n="@@AccountEditorView.Save">Save</sl-button>
        </div>
    </form>
</sl-card>

<sl-auth-profile class="mt-6" [api]="passportApiUrl" (primaryEmailChange)="onPrimaryEmailChange($any($event))"></sl-auth-profile>